import { render, staticRenderFns } from "./PhoneCode.vue?vue&type=template&id=4a35e03b&"
import script from "./PhoneCode.vue?vue&type=script&lang=js&"
export * from "./PhoneCode.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports